import cashGPTIcon from '../../../shared/assets/brand/cashgpt_icon_new.png';

import styles from './chat-message.module.css';

export function BotAvatar() {
	return (
		<div className={styles.botAvatar}>
			<img src={cashGPTIcon} alt='CashGPT' className={styles.botAvatarImage} />
		</div>
	);
}
